// ============================================================================
// ACCOUNT TYPE SERVICE (read-only)
// ============================================================================

import { get } from '../client/axiosClient';
import { accountTypeEndpoints } from '../endpoints/accounts.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  BackendPagedResult,
  PaginatedResponse,
  ID,
  AccountTypeDto,
  AccountTypeQueryParams,
} from '../types';

class AccountTypeService {
  async getAll(params?: AccountTypeQueryParams): Promise<PaginatedResponse<AccountTypeDto>> {
    const endpoint = params
      ? buildEndpointWithQuery(accountTypeEndpoints.list(), params)
      : accountTypeEndpoints.list();
    const response = await get<ApiResponse<BackendPagedResult<AccountTypeDto>>>(endpoint);
    const paged = response.data.data;
    return {
      success: response.data.success,
      message: response.data.message,
      data: Array.from(paged.items || []),
      pagination: {
        currentPage: paged.page,
        pageSize: paged.pageSize,
        totalPages: paged.totalPages,
        totalItems: paged.totalCount,
        hasNextPage: paged.hasNext,
        hasPreviousPage: paged.hasPrevious,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<AccountTypeDto>> {
    const response = await get<ApiResponse<AccountTypeDto>>(accountTypeEndpoints.getById(id));
    return response.data;
  }
}

export const accountTypeService = new AccountTypeService();
export default accountTypeService;
